import axios from "axios"

const apiInstance = axios.create({
    baseURL: "https://matkabar-api.kglame.com",
    // baseURL: "http://localhost:5000"
});

export default apiInstance
